import { render, staticRenderFns } from "./HeaderMenuPrivilege.vue?vue&type=template&id=f39e8628&scoped=true"
import script from "./HeaderMenuPrivilege.vue?vue&type=script&lang=js"
export * from "./HeaderMenuPrivilege.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuPrivilege.vue?vue&type=style&index=0&id=f39e8628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39e8628",
  null
  
)

export default component.exports